const state = {
  history: [],
  importerState: {init: true},
  uploadEvent: {},
  error: {
    error: false,
    type: 'unknown',
    data: {},
  },
  userGroups: {},
  enterPointsManually: false,
  importPoints: 0,
  extraImportPoints: 0,
  selectedUser: null,
  excelUsers: [],
  fetchedUsers: [],
  importerType: [],
  importerTypes: [],
  extraPoints: [],
}

export { state }
